<template>
	<div class="chromecast-screen">
		<div class="chromecast-screen__action-w">
			<button
				@click.stop="$emit('seek', -10)"
			>
				<Icon
					size="xxxl"
					icon-name="backward10"
				/>
			</button>
			<div class="chromecast-screen__action-center">
				<svg
					width="64"
					height="64"
					viewBox="0 0 32 32"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M 6 6 C 4.897 6 4 6.897 4 8 L 4 12 L 6 12 L 6 8 L 26 8 L 26 24 L 18 24 L 18 26 L 26 26 C 27.103 26 28 25.103 28 24 L 28 8 C 28 6.897 27.103 6 26 6 L 6 6 z M 4 14 L 4 16 C 9.169375 16 13.436179 19.942273 13.949219 24.978516 C 13.983421 25.314265 14 25.655375 14 26 L 16 26 C 16 19.383 10.617 14 4 14 z M 4 18 L 4 20 C 7.309 20 10 22.691 10 26 L 12 26 C 12 21.589 8.411 18 4 18 z M 4 22 L 4 26 L 8 26 C 8 23.791 6.209 22 4 22 z"
						fill="currentColor"
					/>
				</svg>
				<Button
					:text="$I18n.trans('view_mode.stop_casting')"
					theme="dark"
					modifier="tertiary"
					size="small"
					@click="$emit('handleChromecastStop')"
				/>
			</div>
			<button
				@click.stop="$emit('seek', 10)"
			>
				<Icon
					size="xxxl"
					icon-name="forward10"
				/>
			</button>
		</div>
		<div
			v-if="audioTracks.length > 1"
			class="chromecast-screen__audio-controls"
			role="group"
			:aria-label="$I18n.trans('view_mode.language')"
			:aria-busy="isAudioTrackPending ? 'true' : 'false'"
		>
			<Button
				v-for="track in audioTracks"
				:key="track.id"
				:text="track.label"
				:modifier="track.id === currentAudioTrackId ? 'primary' : 'tertiary'"
				:aria-pressed="track.id === currentAudioTrackId ? 'true' : 'false'"
				:disabled="isAudioTrackPending"
				theme="dark"
				size="small"
				@click="$emit('set-audio-track', track.id)"
			/>
			<LoadingSpinner
				v-if="isAudioTrackPending"
				size="sm"
				aria-hidden="true"
			/>
		</div>
	</div>
</template>

<script>
import Button from '@shared/components/Button';
import Icon from '@shared/components/Icon';
import LoadingSpinner from '@shared/components/LoadingSpinner.vue';

export default {
	name:       'ChromeCastOverlay',
	components: { Button, Icon, LoadingSpinner },
	props:      {
		audioTracks:         { type: Array, default: () => [] },
		currentAudioTrackId: { type: Number, default: null },
		isAudioTrackPending: { type: Boolean, default: false },
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.chromecast-screen {
	display: flex;
	flex-direction: column;
	justify-content: center;
	gap: $sp4;
	width: 100%;
	padding: $sp4;
	aspect-ratio: 16 / 9;
	background-color: var(--color-grey-950);

	body.-t-light & { // stylelint-disable-line selector-max-type, selector-no-qualifying-type
		background-color: var(--color-grey-050);
	}
}

.chromecast-screen__action-w {
	display: flex;
	justify-content: space-evenly;
	align-items: center;
	width: 100%;
}

.chromecast-screen__action-center {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 1rem;
}

.chromecast-screen__audio-controls {
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: center;
	gap: $sp3;
}
</style>
